import React, { createContext } from 'react';
import { connect } from 'react-redux';
import { selectComorditemCurrent, selectComorderCurrent, selectDraft, selectDraftFreshness, selectDraftLoaded, selectDraftSaved, selectDraftVirbomHeader, selectUserId, selectDraftVirbomHeaderDb } from '../redux/selectors';
import { terCompanyUtils_detect_is_company_orderkey_regular } from '../ter/ter-company-utils';
import { terUsernameById } from '../ter/ter-utils';
import { js_utils } from '../utils/frfr-js-utils';
import Layout from './Layout';


export const SastavljacContext = createContext(null);
/*
Every Context object comes with a Provider React component that allows consuming components to subscribe to context changes.

The Provider component accepts a value prop to be passed to consuming components that are descendants of this Provider. One Provider can be connected to many consumers. Providers can be nested to override values deeper within the tree.

All consumers that are descendants of a Provider will re-render whenever the Provider’s value prop changes.
*/



const AppSastavljac = (props) => {
  // const dispatch = props.dispatch;
  const comorderCurrent = props.comorderCurrent;
  const comorditemCurrent = props.comorditemCurrent;
  const virbom_header = props.virbom_header;
  const virbom_header_db = props.virbom_header_db;

  // preparing context
  let my_user_id = null;
  if (props.my_user_id > 0) {
    my_user_id = props.my_user_id;
  }
  let comorditemCurrent_is_read_only = false;
  let comorderCurrent_id = null;
  // let comorditem_id = null;
  let comorditemCurrent_id = null;
  let company_orderkey = ''; // acKey na primer "2201OR0000510"
  let is_company_orderkey_regular = false; //
  let company_orderitemnumber = null; // anNo redni broj stavke
  let company_filekey = null; // za sad ne postoji stavka narudzbe key dok je ne importujemo???
  let nosilactroska = null;
  let nazivprojekta = null;
  let virbom_rev_id = null;
  let virbom_created_username = null;
  let virbom_created_datetime = null;
  let is_virbom_saved = false;
  if (props.saved === true) {
    is_virbom_saved = true;
  }
  let is_virbom_loaded = false;
  if (props.loaded === true) {
    is_virbom_loaded = true;
  }
  let is_zero_virbom_revs = false;
  if (is_virbom_loaded && virbom_header_db === false) {
    is_zero_virbom_revs = true;
  }
  let _korak_izaberi_stavku_ready = false;
  let _korak_virbom_editable = false;

  let _number_of_completed_steps = 0;

  let _breadcrumb_narudzbe = 'Narudžbe';
  let _breadcrumb_company_orderkey = 'Narudžba: ?';
  let _breadcrumb_stavke = 'Stavke narudžbe';
  let _breadcrumb_company_orderitem = 'Stavka: ?';
  let _breadcrumb_rev_id = 'Revizija: ?';
  let _breadcrumb_step_export = 'Export';
  // TODO dodati jos jedan breadcrumb step kada stavka ima broj stavke???


  //
  if (comorderCurrent && comorderCurrent.id > 0) {
    comorderCurrent_id = comorderCurrent.id;
    _korak_izaberi_stavku_ready = true;
    _breadcrumb_company_orderkey = 'Narudžba: ' + (comorderCurrent.company_orderkey ? (comorderCurrent.company_orderkey) : '');
    _number_of_completed_steps = 2; // 2 koraka odjednom
    if (js_utils.is_number_or_string_not_empty(comorderCurrent.company_orderkey)) {
      company_orderkey = comorderCurrent.company_orderkey;
      is_company_orderkey_regular = terCompanyUtils_detect_is_company_orderkey_regular(company_orderkey);
    }
    if (js_utils.is_number_or_string_not_empty(comorderCurrent.nosilactroska)) {
      nosilactroska = comorderCurrent.nosilactroska;
    }
    if (js_utils.is_number_or_string_not_empty(comorderCurrent.nosilactroska)) {
      nazivprojekta = comorderCurrent.nazivprojekta;
    }
  }
  if (comorditemCurrent && comorditemCurrent.id > 0) {
    //
    if (comorditemCurrent.is_read_only === true) {
      comorditemCurrent_is_read_only = true;
    }
    //
    comorditemCurrent_id = comorditemCurrent.id;
    _number_of_completed_steps = 3;
    if (js_utils.is_number_or_string_not_empty(comorditemCurrent.company_orderitemnumber)) {
      company_orderitemnumber = comorditemCurrent.company_orderitemnumber;
      // _number_of_completed_steps = 4; // ???
    }
    if (js_utils.is_number_or_string_not_empty(comorditemCurrent.company_filekey)) {
      company_filekey = comorditemCurrent.company_filekey;
    }
  }
  if (virbom_header && virbom_header.id) {
    virbom_rev_id = virbom_header.id;
    _breadcrumb_rev_id = 'Revizija: ' + virbom_rev_id;
    _number_of_completed_steps = 5;
    //

    virbom_created_username = terUsernameById(virbom_header.user_created);
    virbom_created_datetime = virbom_header.datetime_created;
  }

  // 

  if (js_utils.is_number_or_string_not_empty(company_orderitemnumber)) {
    _breadcrumb_company_orderitem = 'Stavka broj: ' + (comorditemCurrent.company_orderitemnumber);
  }
  //
  const _breadcrumb_steps = [
    _breadcrumb_narudzbe,
    _breadcrumb_company_orderkey,
    _breadcrumb_stavke,
    _breadcrumb_company_orderitem,
    _breadcrumb_rev_id,
    _breadcrumb_step_export
  ];


  // -----------------


  // context value that will be received by context consumer or useContext
  const contextValue = {
    my_user_id,
    comorditemCurrent_is_read_only,

    comorderCurrent_id,
    comorderCurrent,
    comorditemCurrent_id,
    comorditemCurrent,
    company_orderkey,
    is_company_orderkey_regular, // NOVO 2025-03-03
    company_orderitemnumber,
    company_filekey,
    nosilactroska,
    nazivprojekta,
    is_zero_virbom_revs,
    virbom_rev_id,
    virbom_created_username,
    virbom_created_datetime,
    is_virbom_saved,
    is_virbom_loaded,

    _korak_izaberi_stavku_ready,
    _korak_virbom_editable,

    _breadcrumb_steps,
    _number_of_completed_steps,
    _breadcrumb_company_orderitem,
    _breadcrumb_company_orderkey,
    _breadcrumb_rev_id
  };

  return (
    <>
      <SastavljacContext.Provider value={contextValue}>
        <Layout initialized_all={props.initialized_all} />
      </SastavljacContext.Provider>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    freshness: selectDraftFreshness(state),
    draft: selectDraft(state),
    my_user_id: selectUserId(state),

    comorderCurrent: selectComorderCurrent(state),
    comorditemCurrent: selectComorditemCurrent(state),
    virbom_header: selectDraftVirbomHeader(state),
    virbom_header_db: selectDraftVirbomHeaderDb(state),
    saved: selectDraftSaved(state),
    loaded: selectDraftLoaded(state),
  };
}
export default connect(mapStateToProps)(AppSastavljac);